<template>
  <div>
    <c-loader v-if="!inited" :active="!inited" :height="100" />

    <custom-form
      ref="form"
      :inited="inited"
      :form="form"
      :is-submitted="isSubmitted"
      :blocked="field && field.blocked"
      :warning="showWarning"
      @submit="submit"
      @changeDictionary="changedDictionary = $event"
    />
  </div>
</template>

<script>
import CLoader from "@/components/loader";
import CustomForm from "./CustomForm.vue";

import { CUSTOM_TYPES } from "@/domains/profile/constants/custom-types";
import { CustomFormModel } from "../models/CustomFormModel";

export default {
  components: {
    CLoader,
    CustomForm,
  },
  props: ["field", "saveFieldData", "saveDictionary"],
  data() {
    return {
      inited: false,
      isSubmitted: false,
      form: CustomFormModel(),
      changedDictionary: null,
    };
  },

  computed: {
    showWarning() {
      if (!this.field) return false;
      if (!this.field.blocked) return false;
      const originalName = this.field.name;
      if (originalName !== this.form.data.name) return true;
      if (this.changedDictionary) return true;
      return false;
    },
  },

  async created() {
    this.inited = false;
    if (this.field) {
      this.form.setData(this.field);
      const fieldConfig = this.getFieldConfig(this.field.fieldType);
      if (fieldConfig.isVariants || fieldConfig.isList) {
        await this.$store.dispatch("profile/getDictionary", { fieldId: this.field.parentId }).then((list) => {
          this.form.setVariants(list);
        });
      }
    }
    this.$nextTick(() => {
      this.inited = true;
    });
  },
  methods: {
    getFieldConfig(fieldType) {
      return CUSTOM_TYPES[fieldType];
    },

    reset() {
      this.isSubmitted = false;
      this.form.reset();
    },

    async submit() {
      this.isSubmitted = true;
      if (!this.$refs.form.isValid) {
        return;
      }

      this.$emit("pending", true);

      const editMode = !!this.field;

      const params = this.form.getParams();

      let fieldModel = null;
      const fieldRequest = this.saveFieldData(params).then((model) => {
        fieldModel = model;
        if (this.field) fieldModel.blocked = this.field.blocked;
        return model;
      });

      const type = this.form.data.fieldType;
      const fieldConfig = this.getFieldConfig(type.value);

      if (!fieldConfig.isVariants && !fieldConfig.isList) {
        await fieldRequest;
      } else if (!this.changedDictionary || this.changedDictionary !== type.value) {
        await fieldRequest;
      } else {
        const dictionary = this.form.getDictionary();

        if (editMode) {
          const dictionaryRequest = this.saveDictionary({ dictionary, fieldId: this.field.parentId });
          await Promise.all([fieldRequest, dictionaryRequest]);
        } else {
          await fieldRequest.then((model) => this.saveDictionary({ dictionary, fieldId: model.profile_field_id }));
        }
      }

      this.$emit("submitted", fieldModel);
      this.$emit("pending", false);
    },
  },
};
</script>
